import { AuthUser } from "@constants";

/**
 * Helper function to compare the UID of the current user to some known UID.
 * @param user Known user object (from useAuth)
 * @param userId UID of user being compared against (eg url param)
 * @returns {boolean} true iff currentUser's UID === userId
 */
function userMatchesUID(user: AuthUser | null, userId: string) {
  return !!(
    user &&
    user.firebaseUser &&
    user.firebaseUser.uid &&
    user.firebaseUser.uid === userId
  );
}

/**
 * Gives if the user is currently an admin.
 * @param {AuthUser|null} user Known user object
 * @returns {boolean} true iff user.role === 'admin'
 */
function isUserAdmin(user: AuthUser | null) {
  return !!(user && user.role === "admin");
}

export { userMatchesUID, isUserAdmin };
